import { getDadosCompletos, getMeDadosCompletos } from "../../../API/getDadosCompletos";
import {
  User,
  ContactDetail,
  AddressDetail,
  PersonalData,
  ProfessionalData,
  Disability,
} from "../../../types/Models";

export const organizerUser = async (
  cpf: string | null,
  user: User,
  setUserData: (data: any) => void,
  setPersonalData: (data: PersonalData) => void,
  setAddressData: (data: AddressDetail) => void,
  setContactData: (data: ContactDetail) => void,
  setProfessionalData: (data: ProfessionalData) => void,
  setLoading: (loading: boolean) => void,
  setDisabilities: (data: Disability[]) => void,
  setAreasActivity: (data: number[]) => void
  //setDadosAnterior: (data: any) => void
) => {
  if (!user) return;

  try {
    setLoading(true);

    const dados = cpf ? await getDadosCompletos(cpf) : await getMeDadosCompletos();

    setUserData({
      ...(dados.usuario || {}),
      force_password_change: dados.usuario?.force_password_change === true,
    });

    setContactData({
      telefone_residencial: dados.dadosContato?.telefone_residencial ?? "",
      telefone_celular: dados.dadosContato?.telefone_celular ?? "",
      possui_whatsapp: dados.dadosContato?.possui_whatsapp ?? false,
      telefone_institucional: dados.dadosContato?.telefone_institucional ?? "",
      email_institucional: dados.dadosContato?.email_institucional ?? "",
    });

    setAddressData({
      cep: dados.endereco?.cep ?? "",
      logradouro: dados.endereco?.logradouro ?? "",
      numero: String(dados.endereco?.numero ?? "0"),
      complemento: dados.endereco?.complemento ?? "",
      bairro: dados.endereco?.bairro ?? "",
      cidade: dados.endereco?.cidade ?? "",
      uf: dados.endereco?.uf ?? "",
    });

    setPersonalData({
      rg: dados.dadosPessoais?.rg ?? "",
      emissor: dados.dadosPessoais?.emissor ?? "",
      uf: dados.dadosPessoais?.uf ?? "",
      identidade_genero: dados.dadosPessoais?.identidade_genero ?? "",
      identidade_genero_outros: dados.dadosPessoais?.identidade_genero_outros ?? "",
      cor_raca: dados.dadosPessoais?.cor_raca ?? "",
      data_nascimento: dados.dadosPessoais?.data_nascimento ?? "",
      escolaridade: dados.dadosPessoais?.escolaridade ?? "",
      profissao: dados.dadosPessoais?.profissao ?? "",
      profissao_outros: dados.dadosPessoais?.profissao_outros ?? "",
      possui_nome_social: dados.dadosPessoais?.possui_nome_social ?? false,
      possui_deficiencia: dados.dadosPessoais?.possui_deficiencia ?? false,
      deficiencia_outros: dados.dadosPessoais?.deficiencia_outros ?? "",
      nome_social: dados.dadosPessoais?.nome_social ?? "",
      estrutura_participacao: dados.dadosPessoais?.estrutura_participacao ?? "",
    });

    setProfessionalData({
      ambito_id: dados.dadosProfissionais?.ambito_id ?? "",
      municipio_id: dados.dadosProfissionais?.municipio_id ?? "",
      lotacao_id: dados.dadosProfissionais?.lotacao_id ?? "",
      vinculo_id: dados.dadosProfissionais?.vinculo_id ?? "",
      funcao_id: dados.dadosProfissionais?.funcao_id ?? "",
      superintendencia_id: dados.dadosProfissionais?.superintendencia_id ?? "",
      unidade_id: dados.dadosProfissionais?.unidade_id ?? "",
      diretoria_regional_id: dados.dadosProfissionais?.diretoria_regional_id ?? "",
      diretoria_interna_id: dados.dadosProfissionais?.diretoria_interna_id ?? "",
      orgao_atuacao_id: dados.dadosProfissionais?.orgao_atuacao_id ?? "",
      instituicao_id: dados.dadosProfissionais?.instituicao_id ?? "",
      ambito: dados.dadosProfissionais?.ambito ?? "",
      municipio: dados.dadosProfissionais?.municipio ?? "",
      lotacao: dados.dadosProfissionais?.lotacao ?? "",
      vinculo_empregaticio: dados.dadosProfissionais?.vinculo_empregaticio ?? "",
      funcao_desempenhada: dados.dadosProfissionais?.funcao_desempenhada ?? "",
      superintendencia_assessoria: dados.dadosProfissionais?.superintendencia_assessoria ?? "",
      unidade: dados.dadosProfissionais?.unidade ?? "",
      diretoria_reginal: dados.dadosProfissionais?.diretoria_reginal ?? "",
      diretoria_interna: dados.dadosProfissionais?.diretoria_interna ?? "",
      orgao_atuacao: dados.dadosProfissionais?.orgao_atuacao ?? "",
      instituicao: dados.dadosProfissionais?.instituicao ?? "",
      updated_at: dados.dadosProfissionais?.updated_at ?? null,
    });

    const novasDeficiencias: Disability[] =
      dados.deficiencias?.map((deficiencia: any) => ({
        id: deficiencia.id ?? 0,
        usuario_id: deficiencia.usuario_id ?? 0,
        deficiencia: deficiencia.deficiencia ?? "",
      })) ?? [];

    setDisabilities(novasDeficiencias);

    const novasAreas: number[] =
      dados.professional_areas
        ?.map((area: any) => area.area_id ?? area.id ?? null)
        .filter((id: number | null): id is number => typeof id === "number") ?? [];

    setAreasActivity(novasAreas);

    /*
    setDadosAnterior({
      contato: dados.dadosContato,
      endereco: dados.endereco,
      pessoais: dados.dadosPessoais,
      profissionais: dados.dadosProfissionais,
      deficiencias: novasDeficiencias,
      profissional_areas: novasAreas,
    });
    */

  } catch (error) {
    console.error("Erro ao buscar dados do usuário:", error);
  } finally {
    setLoading(false);
  }
};
